import React from 'react'
import Slider from 'material-ui/Slider'
import { BUTTON_COLOR } from '../constants/colours'

function EmiInput({name,title,value,min,max,step,handleChange,postfix,position,prefix,indent,inputWidth}) {
    const styles = {
        input : {
            color : 'black',
            backgroundColor : '#e9e9e9',
            border : 0,
            textIndent : '10px',
            padding : "6px",
            textIndent : `${indent}px`,
            borderRadius : '6px',
            letterSpacing : '2px',
            width : inputWidth || '100%',
        },
        label : {
            color : 'white',
        },
        prefix : {
            color : 'black',
        },
        postfix : {
            color : 'white',
        }
    }

  return (
    <div>
        <div style={{display : 'flex',justifyContent : 'space-between',alignItems : 'center',padding : 0,margin : 0}}>
            <p style={styles.label}>{title}</p>
            <div style={{position : 'relative',display : 'flex',alignItems : 'center'}}>
            {prefix && <span style={{fontSize : '18px',position : 'absolute',left : '8px', ...styles.prefix}}>{prefix}</span>}
            <input style={styles.input} name={name} value={value} onChange={(e) => handleChange(e.target.name,e.target.value)}/>
            {postfix && <span style={{fontSize : '14px', marginLeft : '8px', whiteSpace : 'nowrap', ...styles.postfix}}>{postfix}</span>}
            </div>
        </div>
        <Slider
        value={value}
        onChange={(event, newValue) => handleChange(name, newValue)}
        name={name}
        min={min}
        max={max}
        step={step}
        color='red'
      />

    </div>
  )
}



export default EmiInput


// WEBPACK FOOTER //
// ./src/components/EmiInput.js